import { ContentState } from '../../hooks/content/useDetailContent'

// Section-level status adapted from the historical content-hardening work.
export const ContentStatus = ({
    state,
    emptyMessage,
}: {
    state: ContentState
    emptyMessage: string
}) => {
    if (state === 'success') return null

    return (
        <p
            className="px-6 py-4 text-center text-neutral-500"
            role={state === 'error' ? 'alert' : 'status'}
        >
            {state === 'loading'
                ? 'Chargement…'
                : state === 'empty'
                ? emptyMessage
                : 'Impossible de charger ce contenu. Veuillez réessayer ultérieurement.'}
        </p>
    )
}
